<template>
  <div class="about text-center">
    <div id="nav" class="mt-0 pt-3 pb-3 bg-white border-bottom">
      <h3 class="m-0">Your Dashboard</h3>
      <router-link :to="`/user/station/${station.id}`">Ground Station Detail</router-link>
    </div>
    <form name="edit_station_form" @submit.prevent="handleSave">
      <div class="mb-4 p-4 border-bottom">
        <div class="container text-left">
          <h3 class="mb-0">
            Edit Ground Station {{ station.id }}
            <div class="pull-right">
              <b-button
                :to="`/user/station/${id}`"
                variant="default"
                class="mr-2">
                Cancel
              </b-button>
              <b-button variant="primary" @click="handleSave">Save</b-button>
            </div>
          </h3>
        </div>
      </div>
      <div class="mb-4 p-4 border-bottom">
        <div class="container text-left">
          <div class="row">
            <div class="col-6">
              <b-card
                title="Basic Info"
                bd-variant="light"
                class="mb-4"
                >
                <div class="row">
                  <div class="col-12">
                    <b-form-group
                      label="UUID"
                      >
                      <input
                        type="text"
                        name="uuid"
                        placeholder="This is auto-generated."
                        class="form-control"
                        :value="station.uuid"
                        disabled
                        aria-label="UUID"
                        >
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-form-group
                      label="Name / Ident"
                      >
                      <input
                        type="text"
                        name="name"
                        placeholder="KE-KMHR1"
                        class="form-control"
                        v-model="station.ident"
                        aria-label="Name / Ident"
                        >
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-form-group
                      label="Description">
                      <b-form-textarea
                        name="description"
                        placeholder="Describe the ground station for its public page."
                        v-model="station.description"
                        class="form-control"
                        aria-label="Description"
                        >
                      </b-form-textarea>
                    </b-form-group>
                  </div>
                </div>
              </b-card>

              <b-card
                title="System"
                bd-variant="light"
                class="mb-4"
                >
                <div class="row">
                  <div class="col-12">
                    <b-form-group
                      label="Platform">
                      <input
                        type="text"
                        name="name"
                        placeholder="Raspberry Pi 3+"
                        class="form-control"
                        v-model="station.systemPlatform"
                        aria-label="Platform"
                        >
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-form-group
                      label="Operating System">
                      <input
                        type="text"
                        name="name"
                        placeholder="Raspbian Buster"
                        class="form-control"
                        v-model="station.systemOS"
                        aria-label="Operating System"
                        >
                    </b-form-group>
                  </div>
                </div>
              </b-card>

              <b-card
                title="Connection"
                sub-title="Automatically detected. If it is wrong, please contact the admin."
                bd-variant="light"
                class="mb-4"
                >
                <div class="row">
                  <div class="col-12">
                    <b-form-group
                      label="Ingest">
                      <input
                        type="text"
                        name="ingest"
                        placeholder="ACARS (Host: feed.airframes.io, Port: 5550)"
                        class="form-control"
                        disabled
                        aria-label="Ingest"
                        >
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <b-form-group
                      label="Feeder Client">
                      <input
                        type="text"
                        name="feeder_client"
                        placeholder="acarsdec"
                        :value="station.sourceApplication"
                        class="form-control"
                        aria-label="Feeder Client"
                        disabled>
                    </b-form-group>
                  </div>
                </div>
              </b-card>
            </div>
            <div class="col-6">
              <b-card
                title="Location"
                sub-title="The location of your radio and antenna."
                bd-variant="light"
                class="mb-4"
                >
                <div class="row">
                  <div class="col-4">
                    <b-form-group
                      label="Latitude">
                      <input
                        type="text"
                        name="latitude"
                        placeholder="38.21312"
                        v-model="station.latitude"
                        class="form-control"
                        aria-label="Latitude"
                        >
                    </b-form-group>
                  </div>
                  <div class="col-4">
                    <b-form-group
                      label="Longitude">
                      <input
                        type="text"
                        name="longitude"
                        placeholder="-121.99112"
                        v-model="station.longitude"
                        class="form-control"
                        aria-label="Longitude"
                        >
                    </b-form-group>
                  </div>
                  <div class="col-4">
                    <b-form-group
                      label="Altitude (feet ASL)">
                      <input
                        type="text"
                        name="altitude"
                        placeholder="50"
                        v-model="station.altitude"
                        class="form-control"
                        aria-label="Altitude"
                        >
                    </b-form-group>
                  </div>
                </div>

                <div class="mb-3 row">
                  <div class="col-12">
                    <b-form-checkbox
                        name="use_fuzzed_location"
                        v-model="station.useFuzzedLocation"
                        aria-label="Fuzz Location"
                        :value="true"
                        :unchecked-value="false"
                        >
                      <span>Fuzz Location by 2 kilometers</span>
                    </b-form-checkbox>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <b-form-group
                      label="Nearest Airport">
                      <input
                        type="text"
                        name="name"
                        placeholder="KMHR"
                        v-model="station.nearestAirportIcao"
                        class="form-control"
                        aria-label="Nearest Airport"
                        >
                    </b-form-group>
                  </div>
                </div>
              </b-card>

              <b-card
                title="Equipment"
                bd-variant="light"
                class="mb-4"
                >
                <div class="row">
                  <div class="col-12">
                    <b-form-group
                      label="SDR">
                      <input
                        type="text"
                        name="sdr"
                        placeholder="RTL-SDR v3"
                        v-model="station.equipmentSdr"
                        class="form-control"
                        aria-label="SDR"
                        >
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-form-group
                      label="Filter">
                      <input
                        type="text"
                        name="sdr"
                        placeholder="FM Bandstop"
                        v-model="station.equipmentFilters"
                        class="form-control"
                        aria-label="Filter"
                        >
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-form-group
                      label="Antenna">
                      <input
                        type="text"
                        name="sdr"
                        placeholder="DPD Airband Outdoor"
                        v-model="station.equipmentAntenna"
                        class="form-control"
                        aria-label="Antenna"
                        >
                    </b-form-group>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

import Map from '@/components/shared/Map.vue';

@Component({
  components: {
    Map,
  },
})
export default class EditUserStation extends Vue {
  id = 0;

  station = {
    id: 'N/A',
    ident: 'N/A',
  };

  submitted = false;

  successful = false;

  @Watch('$route')
  onPropertyChanged(newValue, oldValue) {
    if (newValue.params.id && newValue.params.id !== oldValue.params.id) {
      this.refresh();
    }
  }

  beforeMount() {
    this.refresh();
  }

  handleSave() {
    this.loading = true;
    this.$validator.validateAll().then((isValid) => {
      if (!isValid) {
        this.loading = false;
        return;
      }
      this.station.fuzzedLatitude = null;
      this.station.fuzzedLongitude = null;
      this.$store.dispatch('userStationSave', this.station).then(
        () => {
          console.log('saved');
          this.loading = false;
          this.successful = true;
          Vue.toasted.success('Saved ground station.');
          this.$router.push(`/user/station/${this.station.id}`);
        },
        (error) => {
          console.log('failed');
          this.loading = false;
          this.message = (error.response && error.response.data)
            || error.message
            || error.toString();
          console.log(error);
        },
      );
    });
  }

  fetchStation() {
    console.log('Fetching station.');
    Vue.axios({
      url: `${this.$store.state.apiServerBaseUrl}/stations/${this.id}`,
      method: 'GET',
    }).then((response) => {
      this.station = response.data;
      if (this.station) {
        console.log('Station loaded.', this.station);
      }
    });
  }

  refresh() {
    console.log(this.$route.params);
    this.id = Number(this.$route.params.id);
    this.fetchStation();
  }
}
</script>
